<template>
  <div class="content">
    <div class="content_swipe">
      <van-swipe :loop="true" indicator-color="#fff" @change="onChange">
        <van-swipe-item v-if="videoList.length > 0">
          <video-player
            class="video"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </van-swipe-item>
        <van-swipe-item
          v-for="(image, index) in imageList"
          :key="'img' + index"
        >
          <img class="swipe_img" :src="image" />
        </van-swipe-item>
        <template #indicator>
          <div
            v-if="videoList.length > 0 && swipeIndex == 0"
            class="custom-indicator"
          >
            视频
          </div>
          <div v-else class="custom-indicator">
            {{ videoList.length > 0 ? swipeIndex : swipeIndex + 1 }}/{{
              imageList.length
            }}
          </div>
        </template>
      </van-swipe>
    </div>
    <div class="content-wrapper-below">
      <div class="content-wrapper">
        <p class="title">
          {{ houseDetailData.title }}
        </p>

        <div class="info-row-house">
          <div class="info-row-house-item">
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div class="detailItem_price">{{ houseDetailData.price }}</div>
                <span class="detailItem_unit">万</span>
              </div>
              <div class="info-row-house-item-bottom">价格</div>
            </div>
          </div>
          <div class="info-row-house-line"></div>
          <div
            class="info-row-house-item info-row-house-item-center"
            style="padding: 0 16px"
          >
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div class="detailItem_price detailItem_price_fontSize">
                  {{ room_type.room }}室{{ room_type.office }}厅{{
                    room_type.toilet
                  }}卫
                </div>
              </div>
              <div class="info-row-house-item-bottom">户型</div>
            </div>
          </div>
          <div class="info-row-house-line"></div>
          <div class="info-row-house-item info-row-house-item-center">
            <div class="info-row-house-item-flex-box">
              <div class="info-row-house-item-top">
                <div class="detailItem_price detailItem_price_fontSize">
                  {{ houseDetailData.size }}㎡
                </div>
              </div>
              <div class="info-row-house-item-bottom">面积</div>
            </div>
          </div>
        </div>

        <div class="floorPosition">
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">单价：</div>
            <div class="floorPosition_item_val">
              {{ houseDetailData.unit_price.toFixed(0) }}元/㎡
            </div>
          </div>
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">楼层：</div>
            <div class="floorPosition_item_val">
              {{ floorType[houseDetailData.floor_type] }}/{{
                houseDetailData.total_floor
              }}
            </div>
          </div>
        </div>

        <div class="floorPosition">
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">朝向：</div>
            <div class="floorPosition_item_val">
              {{ houseDetailData.orientation }}
            </div>
          </div>
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">装修：</div>
            <div
              class="floorPosition_item_val"
              v-if="
                houseDetailData.attrib &&
                  houseDetailData.attrib.renovation &&
                  houseDetailData.attrib.renovation.deco
              "
            >
              {{ houseDetailData.attrib.renovation.deco }}
            </div>
          </div>
        </div>

        <div class="floorPosition">
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">年代：</div>
            <div
              class="floorPosition_item_val"
              v-if="
                houseDetailData.attrib &&
                  houseDetailData.attrib.renovation &&
                  houseDetailData.attrib.renovation.house_years
              "
            >
              {{ houseDetailData.attrib.renovation.house_years }}年
            </div>
          </div>
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">类型：</div>
            <div
              class="floorPosition_item_val"
              v-if="
                houseDetailData.attrib && houseDetailData.attrib.house_status
              "
            >
              {{
                houseDetailData.attrib.house_status == 1
                  ? '普通住宅'
                  : '非普通住宅'
              }}
            </div>
          </div>
        </div>

        <div class="floorPosition">
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">产权：</div>
            <div
              class="floorPosition_item_val"
              v-if="
                houseDetailData.attrib &&
                  houseDetailData.attrib.renovation &&
                  houseDetailData.attrib.renovation.property_right
              "
            >
              {{ houseDetailData.attrib.renovation.property_right }}
            </div>
          </div>
          <div class="floorPosition_item">
            <div class="floorPosition_item_key">房龄：</div>
            <div
              class="floorPosition_item_val"
              v-if="
                houseDetailData.attrib &&
                  houseDetailData.attrib.renovation &&
                  houseDetailData.attrib.renovation.house_age
              "
            >
              {{ houseDetailData.attrib.renovation.house_age }}
            </div>
          </div>
        </div>

        <div class="introduce">
          <div
            class="introduce_item"
            v-for="(item, index) in houseDetailData.introduce"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <div class="content-wrapper-map">
        <div class="introduce_title">房源位置</div>
        <div class="map">
          <img
            src="../../assets/house/position@2x.png"
            class="map_icon"
            alt=""
          />
          <div class="map_position">
            <div class="map_position_address">
              {{ houseDetailData.location_address }}
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrapper-highlights">
        <div class="introduce_title">房源亮点</div>
        <div class="txt-box">
          <div
            class="open"
            v-for="(item, index) in houseDetailData.facilitie"
            :key="index"
          >
            {{ item.title }}：{{ item.content }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="isWeixin || isQQ" class="share" @click="open_mask()">
      立即咨询
    </div>
    <div v-else class="share" @click="open_app()">立即咨询</div>
    <div class="weixin-tip" v-if="maskShow">
      <p>
        <img
          v-if="!isIOS"
          src="../../assets/common/live_weixin.png"
          alt="微信打开"
        />
        <img
          v-if="isIOS"
          src="../../assets/common/live_weixin_ios.png"
          alt="微信打开"
        />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isIOS: false,
      isWeixin: false,
      isQQ: false,
      maskShow: false,
      id: '',
      swipeIndex: 0,
      imageList: [],
      videoList: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, //如果true,则自动播放
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 循环播放
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

        sources: [
          {
            // 播放资源和资源格式
            type: 'video/mp4',
            src: '', //你的视频地址（先为空，之后动态赋值）
          },
        ],
        poster: '', //视频封面图
        width: document.documentElement.clientWidth, // 默认视频全屏时的最大宽度
        notSupportedMessage: '加载中...', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      houseDetailData: {},
      room_type: {},
      open: true,
      parmSrc: '',
      indicatorLeft: {
        left: document.documentElement.clientWidth / 2 - 27 + 'px',
      },
      floorType: {
        1: '低楼层',
        2: '中楼层',
        3: '高楼层',
      },
    }
  },
  created() {
    this.id = this.$route.query.id
    var u = navigator.userAgent
    this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1 // 微信内
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (
      u.toLowerCase().indexOf('qq') > -1 &&
      u.toLowerCase().indexOf('mqqbrowser') < 0 &&
      this.isIOS
    ) {
      //qq内置浏览器
      this.isQQ = true
    }
    this.getHouseDetail()
  },
  methods: {
    // 获取房源详情
    getHouseDetail() {
      this.$api
        .get('estate/index/second/estates/detail', {
          id: this.id,
          source: 1,
        })
        .then((res) => {
          if (res) {
            this.houseDetailData = res
            this.room_type = res.room_type
            this.addImgs(res.type)
          }
        })
    },
    addImgs(type) {
      if (
        this.houseDetailData.image.video != null &&
        this.houseDetailData.image.video.length != 0
      ) {
        this.houseDetailData.image.video.forEach((item) => {
          this.videoList.push(item)
        })
        this.playerOptions['sources'][0][
          'src'
        ] = this.houseDetailData.image.video[0]
      }
      if (type == 1) {
        // 客厅图
        this.houseDetailData.image.living_room.forEach((item) => {
          this.imageList.push(item)
        })
        // 卧室
        this.houseDetailData.image.bedroom.forEach((item) => {
          this.imageList.push(item)
        })
        // 卫生间
        this.houseDetailData.image.toilet.forEach((item) => {
          this.imageList.push(item)
        })
        // 厨房
        this.houseDetailData.image.kitchen.forEach((item) => {
          this.imageList.push(item)
        })
        // 户型图
        this.houseDetailData.image.diagram.forEach((item) => {
          this.imageList.push(item)
        })
        // 其它
        this.houseDetailData.image.other.forEach((item) => {
          this.imageList.push(item)
        })
      } else {
        this.houseDetailData.image.living_room.forEach((item) => {
          this.imageList.push(item)
        })
        // 其它
        this.houseDetailData.image.other.forEach((item) => {
          this.imageList.push(item)
        })
      }
    },
    onChange(index) {
      if (this.videoList.length > 0) {
        this.$refs.videoPlayer.player.pause()
      } else {
      }
      this.swipeIndex = index
    },
    open_app() {
      let baseUrl = process.env.VUE_APP_WEEX_HOST
      this.parmSrc = `house/index?house_js=${baseUrl}/secondHandHouseDetail.js?id=${this.id}&baseUrl=${baseUrl}`
      this.openApp('', '', this.parmSrc)
    },
    open_mask() {
      this.maskShow = true
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  overflow: auto;
  background-color: rgba(246, 246, 246, 1);
}

.content_swipe {
  width: 100%;
  height: 282px;
  background-color: #26c165;

  .van-swipe,
  .swipe_img,
  .video {
    width: 100%;
    height: 282px;
  }
}

/deep/.vjs-tech {
  height: 282px;
}

/deep/.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 282px;
}

/deep/.video-js .vjs-big-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-indicator {
  position: absolute;
  right: 16px;
  bottom: 28px;
  width: 55px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  font-weight: 600;
  border-radius: 17px;
  background-color: rgba(0, 0, 0, 0.2);
}
.content-wrapper-below {
  width: 375px;
  position: absolute;
  background-color: rgba(245, 245, 245, 1);
}

.content-wrapper {
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px 1px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin-top: -12px;
}

.content-wrapper-map {
  margin-top: 8px;
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px 1px;
}

.content-wrapper-highlights {
  margin-top: 8px;
  background-color: rgba(255, 255, 255, 1);
  padding: 20px 16px;
  padding-bottom: 70px;
}

.title {
  font-size: 17px;
  font-weight: 600;
  color: #333333;
  vertical-align: middle;
}

.introduce {
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  margin-bottom: 21px;
}

.introduce_item {
  height: 20px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  background: #f5fbff;
  border-radius: 2px;
  font-size: 12px;
  color: #7f8fa0;
}

.info-row-house {
  padding: 16px 0;
  display: flex;
  align-items: center;

  .info-row-house-item {
    display: flex;
    flex: 1;
    // flex-direction: column;
    // background-color: chocolate;
  }

  .info-row-house-item-flex-box {
    display: flex;
    flex-direction: column;
  }

  .info-row-house-item-start {
    justify-content: flex-start;
  }

  .info-row-house-item-center {
    justify-content: center;
  }

  .info-row-house-item-top {
    display: flex;
    margin-bottom: 12px;
    align-items: center;
  }

  .detailItem_price {
    font-size: 1.2em;
    font-weight: 600;
    color: #e94b4b;
    line-height: 17px;
  }

  .detailItem_price_fontSize {
    font-size: 1.2em;
  }

  .detailItem_unit {
    font-size: 12px;
    color: #e94b4b;
    display: inline-block;
    margin-left: 5px;
    line-height: 10px;
  }

  .info-row-house-item-bottom {
    font-size: 12px;
    color: #999999;
  }

  .info-row-house-line {
    height: 32px;
    width: 1px;
    background-color: #eaeaea;
  }
}

.floorPosition {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.floorPosition_item {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.floorPosition_item:first-child {
  margin-right: 70px;
}

.floorPosition_item_key {
  font-size: 14px;
  color: #333333;
  margin-bottom: 16px;
}

.floorPosition_item_val {
  font-size: 14px;
  color: #333333;
  margin-bottom: 16px;
}

.map {
  padding: 14px;
  margin: 20px 0;
  background: #fafbfd;
  border-radius: 2px;
  border: 1px solid #eef2fb;
  display: flex;
  align-items: center;

  .map_icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .map_position {
    display: flex;
    flex-direction: column;

    .map_position_address {
      font-size: 14px;
      color: #333333;
      font-weight: bold;
    }

    .map_position_metro {
      min-height: 14px;
      font-size: 12px;
      color: #999999;
    }
  }
}

.introduce_title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.txt-box {
  display: flex;
  flex-direction: column;
  margin: 16px 0 24px;
}

.open {
  min-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.share {
  width: 222px;
  height: 40px;
  position: fixed;
  bottom: 39px;
  left: 50%;
  transform: translateX(-50%);
  background: #26c165;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
}

.weixin-tip {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);

  p {
    padding: 15px 25px;

    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
